export default {
  currentHash: null,
  latestHash: null,
  updateAvailable: false,
  pollHandle: null,
  pollIntervalMs: 10 * 60 * 1000
}
